import Color from 'color';

/**
 * A safer version of converting colors to hex because `Color` might throw an
 * error.
 *
 * If it is not a valid color, returns `undefined`
 */
export function toHex(color: string): string | undefined {
  try {
    return Color(color).hex();
  } catch {
    return;
  }
}
